import { UseCase } from "../models/UseCase"

export const approximateMinutesUseCase = (useCase: UseCase): number => {
  return approximateMinutes(useCase.sectionCount, useCase.questionCount)
}

export const approximateMinutes = (sectionCount: number, questionCount: number): number => {
  return Math.round(2 * (40 * sectionCount + 15 * questionCount) / 60)
}
